import { FormlyFieldConfig } from '@ngx-formly/core';
import { AllegatiBolliAltroStep } from '../../shared/allegati-bolli-altro.step';
export const OccupazioneCantiereStep : FormlyFieldConfig[] = [
    {
        fieldGroup: [
            {
                wrappers: ['group-panel'],
                key: 'jd.cantiere_occupazione',
                type: 'repeat',
                defaultValue:[],
                fieldGroupClassName:
                    'flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 mt-4 w-full',
                props: {
                    addText: '+ AGGIUNGI ELEMENTO',
                    label: 'ELENCO ELEMENTI DI OCCUPAZIONE SUOLO PER CANTIERE',
                    required: true,
                },
                fieldArray: {
                    fieldGroup: [
                        {
                            fieldGroupClassName:
                                'border border-t-4 p-4 shadow-sm rounded-xl mb-2 grid gap-4',
                            fieldGroup: [
                                {
                                    className: 'sm:col-span-1 md:col-span-6',
                                    key: 'tipologia_occupazione',
                                    type: "mat-select",
                                    props: {
                                        label: 'TIPO DI TARIFFA',
                                        required: true,
                                        options: [
                                            {
                                                value: 1,
                                                label: 'ATTIVITÀ EDILE (PONTEGGIO GALLERIA PEDONALE - STECCATO )',
                                            },
                                            {
                                                value: 2,
                                                label: 'SPAZI SOPRASTANTI O SOTTOSTANTI',
                                            },
                                            {
                                                value: 3,
                                                label: 'ATTIVITÀ EDILE SU STALLI DI SOSTA',
                                            },
                                            {
                                                value: 4,
                                                label: 'TRASLOCHI E OPERAZIONI DI CARICO E SCARICO MERCI O TAGLIO ALBERI',
                                            },
                                            {
                                                value: 5,
                                                label: 'ATTIVITÀ EDILE CON PIATTAFORMA AEREA/AUTOSCALE O OPERAZIONI DI CARICO E SCARICO EDILE',
                                            },
                                            {
                                                value: 6,
                                                label: 'ATTIVITÀ EDILE CON PIATTAFORMA AEREA O AUTOSCALE SU STALLI DI SOSTA',
                                            },
                                            {
                                                value: 7,
                                                label: 'CONTENITORI PORTA A PORTA',
                                            },
                                        ],
                                        change: (field) =>
                                            field.parent
                                                .get(`${field.key}_value`)
                                                .formControl.setValue(
                                                    (
                                                        field.props
                                                            .options as Array<{
                                                            value: any;
                                                            label: string;
                                                        }>
                                                    ).filter(
                                                        (x) =>
                                                            x.value ==
                                                            field.formControl
                                                                .value,
                                                    )[0].label,
                                                ),
                                    }
                                },
                                {
                                    key: 'tipologia_occupazione_value',
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-3',
                                    key: 'elemento',
                                    type:'mat-select',
                                    props: {
                                        label: 'ELEMENTO DI OCCUPAZIONE',
                                        required: true,
                                        options: [
                                            {
                                                value: 1,
                                                label: 'PONTEGGIO SUOLO CON GALLERIA PEDONALE',
                                            },
                                            {
                                                value: 2,
                                                label: 'PONTEGGIO CHIUSO',
                                            },
                                            {
                                                value: 3,
                                                label: 'PONTEGGIO A SOPRASSUOLO',
                                            },
                                            {
                                                value: 8,
                                                label: 'AREA DI CANTIERE',
                                            },
                                        ],
                                        change: (field) =>
                                            field.parent
                                                .get(`${field.key}_value`)
                                                .formControl.setValue(
                                                    (
                                                        field.props
                                                            .options as Array<{
                                                            value: any;
                                                            label: string;
                                                        }>
                                                    ).filter(
                                                        (x) =>
                                                            x.value ==
                                                            field.formControl
                                                                .value,
                                                    )[0].label,
                                                ),
                                    }
                                },
                                {
                                    key: 'elemento_value',
                                },
                                {
                                    "className": 'sm:col-span-1 md:col-span-3',
                                    "key": 'via',
                                    "type":'mat-autocomplete',
                                    "props": {
                                        "label": 'VIA',
                                        "required": true,
                                    },
                                    "validation": {
                                        "show": true,
                                    },
                                    validators:{
                                        validation:['AutocompleteMatch'],
                                    },
                                    hooks: {
                                        onInit: (field) => field.props.filter = (term: string) => field.options.formState.cmp._ubicazioneService.getViaByTerm(term)
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'lunghezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'LUNGHEZZA (m)',
                                        required: true,
                                        type: 'number',
                                    }
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'larghezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'LARGHEZZA (m)',
                                        required: true,
                                        type: 'number',
                                    }
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'altezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'ALTEZZA PONTEGGI (m)',
                                        required: true,
                                        type: 'number',
                                    }
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-3',
                                    key: 'ml_giornalieri',
                                    type: 'mat-input',
                                    props: {
                                        label: ' METRI LINEARI DI OCCUPAZIONE GIORNALIERA',
                                        required: true,
                                        type: 'number',
                                    }
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-3',
                                    key: 'durata',
                                    type: 'mat-input',
                                    defaultValue: '',
                                    props: {
                                        label: 'DURATA (giorni)',
                                        description:
                                            'INDICARE LA DURATA SOLO SE SI TRATTA DI NUMERO DI GIORNI DIVERSI DA QUELLO INDICATO NELLA PRATICA',
                                    }
                                },

                                {
                                    className: 'sm:col-span-1 md:col-span-6',
                                    key: 'descrizione',
                                    type:'mat-textarea',
                                    defaultValue: '',
                                    props: {
                                        label: 'INDICARE POSIZIONE ESATTA (UBICAZIONE DA CIVICO A CIVICO) E COSA SI OCCUPA (CARREGGIATA, STALLO DI SOSTA, AREA PEDONALE, ...)',
                                        autosize: true,
                                        required: true,
                                        autosizeMaxRows: 8,
                                        autosizeMinRows: 2,
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        ],
    },
            ...AllegatiBolliAltroStep
];
